import styles from './CollaborationCard.module.css';

/**
 * CollaborationCard — a compact XP-window "preview" tile.
 *
 * The card shows just a teaser (title bar + subtitle + short description).
 * Clicking anywhere on it (or pressing Enter/Space) opens the full
 * draggable CyberLunaWindow modal, where all the detail lives.
 *
 * @param {string}   title       - Window title-bar text
 * @param {string}   subtitle    - Short eyebrow label
 * @param {string}   description - Teaser copy (clamped)
 * @param {() => void} onOpen    - Opens the full modal
 */
const CollaborationCard = ({ title, subtitle, description, onOpen }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen?.();
    }
  };

  return (
    <article
      className={styles.card}
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={handleKeyDown}
      aria-label={`${title} — open details`}
    >
      {/* XP-style window title bar (controls are decorative — the real ones live in the modal) */}
      <div className={styles.titleBar}>
        <span className={styles.titleBarIcon} aria-hidden="true">◈</span>
        <span className={styles.titleBarText}>{title}</span>
        <span className={styles.titleBarControls} aria-hidden="true">
          <span className={styles.tbBtn}><span className={styles.tbMin} /></span>
          <span className={styles.tbBtn}><span className={styles.tbMax} /></span>
          <span className={`${styles.tbBtn} ${styles.tbClose}`}>✕</span>
        </span>
      </div>

      <div className={styles.cardHeader}>
        <span className={styles.cardLabel}>{subtitle}</span>
      </div>

      <div className={styles.cardBody}>
        <p className={styles.description}>{description}</p>
      </div>

      <div className={styles.cardFooter}>
        <span className={styles.openHint} aria-hidden="true">Open ↗</span>
      </div>
    </article>
  );
};

export default CollaborationCard;
